import { render } from "./typeFilterDropdown.vue?vue&type=template&id=9ab2ba60"
import script from "./typeFilterDropdown.vue?vue&type=script&lang=js"
export * from "./typeFilterDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script